import { createReducer } from '@reduxjs/toolkit';
import { cartLoaded } from './action';
import initialCartState from './state';

const cartReducer = createReducer(initialCartState, (builder) => {
    builder.addCase(cartLoaded, (state, { payload }) => payload);
});

export default cartReducer;
